/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import type { GetBanksInternalServerErrorDto } from '../../src/model';
// @ts-ignore
import type { GetBanksOkDto } from '../../src/model';
/**
 * BankApi - axios parameter creator
 * @export
 */
export const BankApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary 은행 전체 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankControllerGetBadgeCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/bank`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BankApi - functional programming interface
 * @export
 */
export const BankApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BankApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary 은행 전체 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async bankControllerGetBadgeCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetBanksOkDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.bankControllerGetBadgeCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BankApi.bankControllerGetBadgeCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BankApi - factory interface
 * @export
 */
export const BankApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BankApiFp(configuration)
    return {
        /**
         * 
         * @summary 은행 전체 조회
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        bankControllerGetBadgeCategories(options?: RawAxiosRequestConfig): AxiosPromise<GetBanksOkDto> {
            return localVarFp.bankControllerGetBadgeCategories(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BankApi - object-oriented interface
 * @export
 * @class BankApi
 * @extends {BaseAPI}
 */
export class BankApi extends BaseAPI {
    /**
     * 
     * @summary 은행 전체 조회
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BankApi
     */
    public bankControllerGetBadgeCategories(options?: RawAxiosRequestConfig) {
        return BankApiFp(this.configuration).bankControllerGetBadgeCategories(options).then((request) => request(this.axios, this.basePath));
    }
}

